export const LOAD_CLAVESUNIDAD_SUCCESS = 'LOAD_CLAVESUNIDAD_SUCCESS';

export interface ClaveUnidadState {
    clave: string
    descripcion: string
    descripcionMercancia:string
    uuidComprobante?: string
    peso?: number
}

interface ILoadClavesUnidad {
    type: typeof LOAD_CLAVESUNIDAD_SUCCESS
    clavesUnidad: ClaveUnidadState[]
}

export type  ClaveUnidadActionTypes = ILoadClavesUnidad
